import Link from 'next/link'
import { useRouter } from 'next/router'

import Button from 'components/forms/Button'
import useShoppingBag from 'common/useShoppingBag'
import { generateSrcSet } from 'project/image-proxy-web'
import { AppStoreButton, GooglePlayButton } from 'components/AppDownloadButtons'

const AppPromoCard = ({ planSummary }: { planSummary?: any }) => {
  const router = useRouter()
  const { addPlan } = useShoppingBag()

  const onBuyClick = () => {
    addPlan(planSummary.slug, 'year', planSummary)
    router.push('/checkout')
  }
  return (
    <div className='card ps-4 ps-lg-20 pe-4 pe-lg-0 py-8 pt-lg-15 pb-0'>
      <div className='row'>
        <div className='col-12 col-lg-7 pb-lg-7 pb-4'>
          <h2 className='lh-105 fw-semibold fs-fluid-40-80'>
            Organise, sort and manage your business mail correspondence with our
            <span className='color-pink2'> app.</span>
          </h2>
          <h3 className='fw-semibold mb-2 lh-114 fs-fluid-20-28 color-grey5 pt-1 pt-lg-3'>
            All your mail is processed and scanned by our AI assistant, HaiRo™
            before it gets sent directly to the app, where it's summarised,
            intelligently tagged, and fully searchable.
          </h3>
          <div className='fw-semibold fs-fluid-18-22'>
            Whether you're on the go or at your desk, managing your business
            mail has never been easier or more efficient.
          </div>
          <img
            {...generateSrcSet('/images/new/app-ui-showcase.png', 361, 620)}
            alt='Customer app screenshot displaying mail interface'
            className='w-100 object-fit-contain d-block d-lg-none'
            height={620}
            width={361}
            loading='lazy'
            style={{
              maxHeight: 600,
            }}
          />
          {!!planSummary && (
            <Button
              onClick={onBuyClick}
              className='mt-lg-3 px-22 w-100 w-lg-auto'
            >
              Buy Now
            </Button>
          )}
          <div className='d-flex gap-3 pt-8 pt-lg-7 justify-content-center justify-content-lg-start'>
            <AppStoreButton />
            <GooglePlayButton />
          </div>
          <div className='text-center text-lg-start'>
            <div className='fs-16 mt-2 lh-22'>
              Requires an active{' '}
              <Link href='/virtual-office-london-old-street'>
                virtual office
              </Link>{' '}
              subscription
            </div>
          </div>
        </div>
        <div className='col-12 col-lg-5 d-none d-lg-block'>
          <div className='position-relative h-100'>
            <img
              {...generateSrcSet(
                '/images/new/app-ui-showcase-cut.png',
                511,
                773,
              )}
              alt='Customer app screenshot displaying mail interface'
              className='rounded-img w-100 h-100 object-fit-contain object-position-bottom d-none d-lg-block'
              height={773}
              width={511}
              loading='lazy'
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default AppPromoCard
